import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "onboarding-step" }

import { ref, watch } from 'vue'
import TagInput from '@/components/common/TagInput.vue'

interface StepData {
  fieldsOfInterest: string[]
  keywordsToMonitor: string[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingStep2',
  props: {
    initialData: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const localData = ref<StepData>({
  fieldsOfInterest: [...props.initialData.fieldsOfInterest],
  keywordsToMonitor: [...props.initialData.keywordsToMonitor],
})

const emitUpdate = () => {
  emit('update', {
    fieldsOfInterest: [...localData.value.fieldsOfInterest],
    keywordsToMonitor: [...localData.value.keywordsToMonitor],
  })
}

watch(() => props.initialData, (newData) => {
  localData.value = {
    fieldsOfInterest: [...newData.fieldsOfInterest],
    keywordsToMonitor: [...newData.keywordsToMonitor],
  }
}, { deep: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "step-title" }, "Content preferences", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("p", { class: "step-description" }, " Help us understand what topics you want to cover and monitor. ", -1)),
    _createVNode(TagInput, {
      modelValue: localData.value.fieldsOfInterest,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((localData.value.fieldsOfInterest) = $event)),
        emitUpdate
      ],
      label: "Fields of Interest (press enter to save)",
      placeholder: "e.g., SaaS, Marketing, AI"
    }, null, 8, ["modelValue"]),
    _createVNode(TagInput, {
      modelValue: localData.value.keywordsToMonitor,
      "onUpdate:modelValue": [
        _cache[1] || (_cache[1] = ($event: any) => ((localData.value.keywordsToMonitor) = $event)),
        emitUpdate
      ],
      label: "Keywords to Monitor (press enter to save)",
      placeholder: "e.g., content marketing, SEO"
    }, null, 8, ["modelValue"])
  ]))
}
}

})